import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import { Actions, ActionTypes } from '../actions/welcomerPopupActions';

export interface IWelcomerPopupState {
  type?: ActionTypes;
  status?: ActionStatus;
  showWelcomerPopup: boolean;
}

const initialState: IWelcomerPopupState = {
  showWelcomerPopup: false
};

export default function welcomerPopupReducer(state = initialState, action: Actions): IWelcomerPopupState {
  switch (action.type) {
    case ActionTypes.showWelcomerModal:
      return { ...state, showWelcomerPopup: true };
    case ActionTypes.hideWelcomerModal:
      return { ...state, showWelcomerPopup: false };
    default:
      return state;
  }
}
